@if (watchlistEnabled$ | async) { @switch (buttonMode$ | async) { @case ('iconOnly') {
<button
  mat-button
  class="button--icon-only action"
  disableRipple="true"
  (click)="onToggleItem($event)"
  [attr.title]="buttonText$ | async">
  <ng-container *ngTemplateOutlet="watchlistIcon"></ng-container>
</button>
} @case ('fullSelected') {
<button class="button--icon-with-text action" mat-stroked-button color="primary" (click)="onToggleItem($event)">
  <ng-container *ngTemplateOutlet="watchlistIcon"></ng-container>
  {{ buttonText$ | async }}</button
>
} @case ('fullUnselected') {
<button class="button--icon-with-text action" mat-flat-button color="primary" (click)="onToggleItem($event)">
  <ng-container *ngTemplateOutlet="watchlistIcon"></ng-container>
  {{ buttonText$ | async }}</button
>
} } }
<ng-template #watchlistIcon>
  <mat-icon class="action__icon material-icons--zoomed" [class.action__icon--active]="itemSelected$ | async"
    >star</mat-icon
  >
</ng-template>
